import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  showCurrencyConversionRateModalForAddEdit,
} from './store/actions';

import { CurrencyConversionRatesPropTypes } from '../../shared/propTypes/currencyConversionRate';
import { PeriodPropTypes } from '../../shared/propTypes/period';
import HamburgerDropdown from '../shared/hamburgerDropdown.component';
import Spinner from '../../shared/spinner.component';
import { waitForSpinnerToShowUp } from '../../shared/cursorHelpers';

import config from '../../config';

function CustomHamburgerDropdown({
  canModifyInSelectedPeriod,
  missingRates,
  templateFileName,
  showCurrencyConversionRateModalForAddEdit,
  fileToImportChange,
  fileToImportSelect,
  exportToExcel,
  exportMissingRatesToExcel,
  isFetchingCurrencyConversionRates,
}) {
  const [isGeneratingExport, setIsGeneratingExport] = useState(false);
  const exportMissingRatesToExcelHandler = useCallback(
    () => {
      setIsGeneratingExport(true);
      waitForSpinnerToShowUp({
        action: exportMissingRatesToExcel,
        callback: () => setIsGeneratingExport(false),
      });
    },
    [exportMissingRatesToExcel]
  );
  const renderExportMissingRates = useCallback(() => missingRates.length > 0 && (
    <button
      key="export-missing-rates"
      className="hamburger-action link-button"
      tabIndex="0"
      onClick={exportMissingRatesToExcelHandler}
    >
      {isGeneratingExport
        ? (
          <span>
            <Spinner small /> Exporting
          </span>
        ) : 'Export Missing Rates to Excel'
      }
    </button>
  ), [missingRates, exportMissingRatesToExcelHandler, isGeneratingExport]);

  return (
    <HamburgerDropdown
      canModify={canModifyInSelectedPeriod}
      showModalForAdd={showCurrencyConversionRateModalForAddEdit}
      addEntityMessage="Add Currency Conversion Rate"
      fileToImportChange={fileToImportChange}
      fileToImportSelect={fileToImportSelect}
      templateFileName={templateFileName}
      templatePath={config.templates.CURRENCY_CONVERSION_RATES}
      exportToExcel={exportToExcel}
      disableImporting={isFetchingCurrencyConversionRates}
      hasMissingRates={missingRates.length > 0}
      additionalItems={[renderExportMissingRates()]}
    />
  );
}

CustomHamburgerDropdown.propTypes = {
  canModifyInSelectedPeriod: PropTypes.bool.isRequired,
  missingRates: CurrencyConversionRatesPropTypes,
  period: PeriodPropTypes,
  showCurrencyConversionRateModalForAddEdit: PropTypes.func.isRequired,
  fileToImportChange: PropTypes.func.isRequired,
  fileToImportSelect: PropTypes.func.isRequired,
  exportToExcel: PropTypes.func.isRequired,
  exportMissingRatesToExcel: PropTypes.func.isRequired,
  templateFileName: PropTypes.string.isRequired,
  isFetchingCurrencyConversionRates: PropTypes.bool.isRequired,
};

export default connect(
  null,
  {
    showCurrencyConversionRateModalForAddEdit,
  }
)(CustomHamburgerDropdown);
